import { render, staticRenderFns } from "./XSolid.vue?vue&type=template&id=c1164e60&"
import script from "./XSolid.vue?vue&type=script&lang=ts&"
export * from "./XSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports